import { fromEvent, Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay, skip, startWith } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { lastValue } from '@app/shared/operators/last-value.operator';

export type WindowLayout = 'MOBILE' | 'DESKTOP';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  readonly layout$: Observable<WindowLayout> = fromEvent(window, 'resize', { passive: true }).pipe(
    startWith(0),
    map(() => (window.innerWidth < 576 ? 'MOBILE' : 'DESKTOP') as WindowLayout),
    distinctUntilChanged(),
    shareReplay(1),
  );

  getLayout(): WindowLayout {
    return lastValue(this.layout$);
  }

  onChange(): Observable<WindowLayout> {
    return this.layout$.pipe(skip(1));
  }
}
